import { ViewModel,View } from "binder"
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { IbanSelectorSelectorViewModel } from "src/erp/arap/rawData/ibanSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IReceiveInfoProvider } from "../IGateway";
import  { IbanGatewayView } from "./ibanGateway-view"

export class IbanGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    get title(): string {
        return translate("ibanGateway-viewModel.Iban",{});
    }
    
    GetDefaultView(): View <ViewModel> {
        return new IbanGatewayView();
    }
    public getTypeId(): string {
        return "VM-91584E71-A020-490C-9B0D-B91408204ECD"
    }

    public set accountSelector(v: IbanSelectorSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): IbanSelectorSelectorViewModel { return this._accountSelector;} private _accountSelector: IbanSelectorSelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    
    initialLoad(): void {
        this.accountSelector = new IbanSelectorSelectorViewModel(this);
    }
    async save(dataProvider: IReceiveInfoProvider): Promise<any> {
        return await ServerConnection.callServer('Complex/ArapServices/CreateIbanTransferReceivable',{
            ReceivableInfo:dataProvider.getBaseReceivableInfoDto(),
            AccountId:this.accountSelector.selectedItem.id,
            TraceCode:this.traceCode
        });    
    }
    validate(): string[] {
        let result = [];
        if(stringIsNullOrEmpty(this.traceCode)){
            result.push(translate("ibanGateway-viewModel.trackingCodeError",{}));
        }
        if(this.accountSelector.selectedItem==null){
            result.push(translate("ibanGateway-viewModel.destinationAccount",{}));
        }
        return result;
    }
}
